/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { responsesPartMeta } from '../models/responsesPartMeta';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class SecurityGroupsProcessesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * call a configured api endpoint to create security groups from an external source
   * @param requestBody
   * @returns any Successfully created security groups from external source
   * @throws ApiError
   */
  public postApiServicesecurityProcessesExternalSecurityGroupsSyncExternalHireSecurityGroups(
    requestBody: {
      companiesToSync: Array<{
        hireAccountBaseUrl?: string;
        hireAccountApiKey?: string;
        uuid?: string;
      }>;
      /**
       * batch size
       */
      perPage?: number;
      type: string;
      /**
       * schedule sync on a recurring basis, frequency is required if true
       */
      schedule: boolean;
      /**
       * frequency in minutes for recurring sync
       */
      frequency?: number;
    },
  ): CancelablePromise<{
    meta?: responsesPartMeta;
    success?: boolean;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/externalSecurityGroups/syncExternalHireSecurityGroups',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * endpoint to unschedule security groups sync
   * @param requestBody
   * @returns any Successfully unscheduled security group sync event
   * @throws ApiError
   */
  public postApiServicesecurityProcessesExternalSecurityGroupsStopSyncExternalHireSecurityGroups(
    requestBody: {
      companiesToStopSync: Array<{
        uuid?: string;
      }>;
    },
  ): CancelablePromise<{
    meta?: responsesPartMeta;
    success?: boolean;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/externalSecurityGroups/stopSyncExternalHireSecurityGroups',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * call a configured api endpoint to attempt to resync external employer securitygroup access
   * @param requestBody
   * @returns any Processed external employers security groups cleanup
   * @throws ApiError
   */
  public postApiServicesecurityProcessesExternalSecurityGroupsCleanupExternalEmployerSecurityGroups(
    requestBody: {
      companiesToSync: Array<{
        hireAccountBaseUrl?: string;
        hireAccountApiKey?: string;
        uuid?: string;
      }>;
      perPage?: number;
      type: string;
      /**
       * schedule sync on a recurring basis, frequency is required if true
       */
      schedule: boolean;
      /**
       * frequency in minutes for recurring sync
       */
      frequency?: number;
    },
  ): CancelablePromise<{
    meta?: responsesPartMeta;
    success?: boolean;
    processed?: number;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/externalSecurityGroups/cleanupExternalEmployerSecurityGroups',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Unschedule employer sync cleanup event for given companies
   * @param requestBody
   * @returns any Successfully unscheduled employers re-sync event
   * @throws ApiError
   */
  public postApiServicesecurityProcessesExternalSecurityGroupsStopCleanupExternalEmployerSecurityGroups(
    requestBody: {
      companiesToStopSync: Array<{
        uuid?: string;
      }>;
    },
  ): CancelablePromise<{
    meta?: responsesPartMeta;
    success?: boolean;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/externalSecurityGroups/stopCleanupExternalEmployerSecurityGroups',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

}
